// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"280":"c20f9ef7","289":"8767a431","319":"a057c325","426":"8d2176f2","567":"c3b94bc6","670":"371b2c99","727":"7e51b25d","828":"ab845a33","889":"9f2a009d","929":"268e1326"}[chunkId] + ".chunk.css";
};